import { useAuth } from '@/context';
import Button from '@/features/shared/Button';
import { Theme } from '@/utils/constants';
import React, { useCallback } from 'react';
import { useStorageState } from 'react-storage-hooks';
import { AccountMenuProps } from './AccountMenu.interfaces';
import useAccountMenuStyles from './AccountMenu.styles';
import AccountNavigationSection from './components/AccountNavigationSection';

const AccountMenu = ({ labels, navSections }: AccountMenuProps) => {
  const classes = useAccountMenuStyles();
  const { logOut } = useAuth();
  const [, setIsLoggingOutAttempt] = useStorageState<boolean>(
    sessionStorage,
    'DATALAYER.IS_LOGGING_OUT_ATTEMPT',
    false,
  );

  const handleLogoutClick = useCallback(() => {
    logOut();
    setIsLoggingOutAttempt(true);
  }, [logOut, setIsLoggingOutAttempt]);

  return (
    <div>
      <div className={classes.sections}>
        {navSections?.map((navSection, index) => (
          <AccountNavigationSection title={navSection.title} links={navSection.links} key={index} />
        ))}
      </div>
      <div>
        <Button
          outlined
          theme={Theme.dark}
          className={classes.logoutButton}
          onClick={handleLogoutClick}
        >
          {labels?.logoutLabel || 'Logout'}
        </Button>
      </div>
    </div>
  );
};

export default AccountMenu;
